/* eslint-disable max-len */
import React from 'react';

const NewsIcon: React.FC<object> = () => {
    return (
        <svg
            width="18"
            height="18"
            viewBox="0 0 18 18"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path d="M8.16642 3.90183V15.0343C8.16618 15.3797 8.04404 15.7139 7.82154 15.9781C7.59903 16.2423 7.29043 16.4195 6.9501 16.4785C6.60977 16.5374 6.25954 16.4744 5.96113 16.3005C5.66272 16.1265 5.43527 15.8528 5.31884 15.5276L3.52962 10.4023M3.52962 10.4023C2.82229 10.1015 2.24057 9.56644 1.88294 8.88607C1.5253 8.20569 1.41369 7.42265 1.56701 6.66944C1.72033 5.91624 2.12916 5.23914 2.72431 4.75273C3.31946 4.26631 4.06437 4.00047 4.833 4.00017H6.35971C9.77647 4.00017 12.7141 2.97177 13.9999 1.5V13.1675C12.7141 11.6957 9.7773 10.6673 6.35971 10.6673H4.833C4.38518 10.668 3.94185 10.5773 3.52962 10.4023ZM13.9999 9.83391C14.663 9.83391 15.2989 9.5705 15.7677 9.10163C16.2366 8.63275 16.5 7.99683 16.5 7.33374C16.5 6.67065 16.2366 6.03472 15.7677 5.56585C15.2989 5.09697 14.663 4.83356 13.9999 4.83356V9.83391Z" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round"/>
        </svg>

    );
};

export default NewsIcon;